import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { product } from '../data/ebook';
import { trackEvent } from '../utils/metaPixel';
export const PRICE_ANCHOR_ID = 'precio';
type BuyButtonProps = {
  children: React.ReactNode;
  variant?: 'solid' | 'light';
  className?: string;
  /** When true the button is the final purchase action instead of a scroll link. */
  isCheckout?: boolean;
};
const base = 'group inline-flex items-center justify-center gap-2.5 rounded-full px-8 py-4 text-sm font-semibold tracking-wide transition-[background-color,transform,box-shadow] duration-150 ease-out active:translate-y-px';
const variants = {
  solid: 'bg-sage-dark text-white shadow-sm hover:bg-ink',
  light: 'bg-white text-ink hover:bg-sage-light'
};
export function BuyButton({
  children,
  variant = 'solid',
  className = '',
  isCheckout = false
}: BuyButtonProps) {
  const content = <>
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-65" data-mp="3s7tmwlvmkzl" />
    </>;
  if (isCheckout) {
    const handleCheckoutClick = () => {
      trackEvent('AddToCart', {
        content_name: product.title,
        content_type: 'product',
        content_ids: ['vientre-plano-express-7-dias'],
        value: Number(product.price),
        currency: product.currency
      });
    };
    return <a href={product.checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className={`${base} ${variants[variant]} ${className}`} data-id="element-66" data-mp="ojzo7o5tnj10">
        {content}
      </a>;
  }
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(PRICE_ANCHOR_ID);
    if (!target) return;
    event.preventDefault();
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: prefersReduced ? 'auto' : 'smooth',
      block: 'center'
    });
    window.history.replaceState(null, '', `#${PRICE_ANCHOR_ID}`);
  };
  return <a href={`#${PRICE_ANCHOR_ID}`} onClick={handleClick} className={`${base} ${variants[variant]} ${className}`} data-id="element-67" data-mp="3hvzr3tu9klww">
      {content}
    </a>;
}